import React, { useEffect, useState } from 'react';
import { AppAutocomplete } from '../../ui';
import { useChiffrageEntrepriseSearch } from '../../../hooks/useChiffrageEntrepriseSearch';

const ChiffrageEntrepriseAutocomplete = ({
  value,
  onSelect,
  disabled = false,
  dolibarrConfigured = true,
}) => {
  const [inputValue, setInputValue] = useState(value ?? '');

  useEffect(() => {
    setInputValue(value ?? '');
  }, [value]);

  const { suggestions, loading } = useChiffrageEntrepriseSearch(inputValue);

  return (
    <AppAutocomplete
      className="chiffrage-entreprise-autocomplete"
      size="sm"
      value={inputValue}
      onChange={(next) => {
        setInputValue(next);
        onSelect?.({ id: null, nom: next });
      }}
      onSelect={(entreprise) => {
        setInputValue(entreprise.nom ?? '');
        onSelect?.({
          id: entreprise.id,
          nom: entreprise.nom ?? '',
        });
      }}
      items={suggestions}
      loading={loading}
      disabled={disabled || !dolibarrConfigured}
      getItemKey={(entreprise) => entreprise.id}
      renderItem={(entreprise) => (
        <>
          {entreprise.nom}
          {entreprise.siret && (
            <span className="text-secondary-light ms-2 small">
              SIRET {entreprise.siret}
            </span>
          )}
        </>
      )}
      placeholder={dolibarrConfigured ? 'Rechercher un client Dolibarr…' : 'Dolibarr non configuré'}
      emptyMessage="Aucun client Dolibarr trouvé"
      loadingLabel="Recherche Dolibarr…"
    />
  );
};

export default ChiffrageEntrepriseAutocomplete;
